/**
 * Custom errors for the Command-Driven State Engine.
 */

export class StoreNotMountedError extends Error {
  constructor( storeName: string, commandType: string ) {
    super( `Cannot execute "${commandType}": the ${storeName} store is not available. Navigate to the correct page first.` );
    this.name = 'StoreNotMountedError';
  }
}

export class CommandRejectedError extends Error {
  constructor() {
    super( 'This action requires manual execution' );
    this.name = 'CommandRejectedError';
  }
}
